// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loading Indicator */
loading-indicator {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 9998;
}

.loading-backdrop {
  position: fixed;
  inset: 0;
  background-color: transparent;
  backdrop-filter: blur(4px);
  z-index: 9998;
}

.loading-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background-color: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: 9999;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/loading.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf","sourcesContent":["/* Loading Indicator */\nloading-indicator {\n  display: none;\n  position: fixed;\n  inset: 0;\n  z-index: 9998;\n}\n\n.loading-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: transparent;\n  backdrop-filter: blur(4px);\n  z-index: 9998;\n}\n\n.loading-spinner {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  background-color: var(--surface);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  z-index: 9999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
